export default __webpack_public_path__ + "static/media/successStatus.7fce1733.png";